import React from 'react';
import pluralize from 'pluralize';
import styles from './TagPopover.module.scss';
import { TagsPanel, TagsPanelProps } from './TagsPanel';
import { ButtonType, ButtonVariant } from 'components/core/Button';
import {
  Button,
  Icon,
  IconList,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'components/core';

export type TagPopoverProps = Omit<TagsPanelProps, 'layout'>;

class ButtonPropsType {
  type: ButtonType = 'brand';
  variant: ButtonVariant = 'outline';
}

export const TagPopover = (panelProps: TagPopoverProps) => {
  const { studiesSelectedCount = 0 } = panelProps;
  const hasStudiesSelected = studiesSelectedCount > 0;
  const buttonProps: ButtonPropsType = hasStudiesSelected
    ? { type: 'brand', variant: 'solid' }
    : { type: 'neutral', variant: 'outline' };

  const studyCountText = `${studiesSelectedCount} ${pluralize(
    'study',
    studiesSelectedCount
  )}`;

  return (
    <Popover strategy="fixed" closeOnEscape={true} forcePlacement>
      <PopoverTrigger>
        <Button
          type={buttonProps.type}
          variant={buttonProps.variant}
          data-pendo-key={hasStudiesSelected ? 'tags' : 'tags-disabled'}
        >
          <Icon icon={IconList.light.faTag} />
          Tag
          {studiesSelectedCount > 0 && ` (${studyCountText})`}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={styles.TagPopover}
        noRightPadding={true}
        aria-label="Apply tags to studies"
        hideArrow={true}
      >
        <TagsPanel {...panelProps} />
      </PopoverContent>
    </Popover>
  );
};
